import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  & > :first-child {
    margin-bottom: 0;
  }
`;
